exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".deleted {\r\n  background-color: rgba(40, 40, 40, 0.2) !important;\r\n  display: none;\r\n}\r\n\r\n.invited {\r\n  background-color: rgba(40, 40, 40, 0.2) !important;\r\n}\r\n\r\n.invite-button {\r\n  transition: background-color ease 0.8;\r\n}\r\n\r\n.user-loading {\r\n  background-color: #0086F4;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/components/group-details-member/group-details-member.component.css
// module id = ../../../../../src/app/components/group-details-member/group-details-member.component.css
// module chunks = 0